import api from "../../../api";

const API_URL = "/crm/roles"; // Updated to match your backend endpoint

export async function getRoles() {
  try {
    const res = await api.get(API_URL);
    return res.data;
  } catch (error) {
    console.error('Error fetching roles:', error);
    // Return empty array if API fails
    return [];
  }
}

export async function getRole(id) {
  try {
    const res = await api.get(`${API_URL}/${id}`);
    return res.data;
  } catch (error) {
    console.error('Error fetching role:', error);
    throw error;
  }
}

// These functions might not be needed since roles are predefined
export async function createRole(data) {
  try {
    const res = await api.post(API_URL, data);
    return res.data;
  } catch (error) {
    console.error('Error creating role:', error);
    throw error;
  }
}

export async function updateRole(id, data) {
  try {
    const res = await api.put(`${API_URL}/${id}`, data);
    return res.data;
  } catch (error) {
    console.error('Error updating role:', error);
    throw error;
  }
}

export async function deleteRole(id) {
  try {
    return await api.delete(`${API_URL}/${id}`);
  } catch (error) {
    console.error('Error deleting role:', error);
    throw error;
  }
}

export async function getRoleOptions() {
  try {
    const res = await api.get("/auth/role-options");
    // expects [{ id, value: "ROLE_*", label: "..." }]
    return res.data;
  } catch (error) {
    console.error("Error fetching role options:", error);
    return [];
  }
} 